document.addEventListener('DOMContentLoaded', () => {
  const ajaxCart = {
    init() {
      console.log('AJAX Cart: init() called.');
      const isCartPage = document.querySelector('.template-cart');
      console.log('AJAX Cart: Is this the cart page?', !!isCartPage);

      // If we are on the main cart page (identified by .template-cart), do not initialize the AJAX cart.
      if (isCartPage) {
        console.log('AJAX Cart: Aborting initialization on cart page.');
        return;
      }

      console.log('AJAX Cart: Continuing initialization.');
      this.drawer = document.getElementById('ajax-cart-drawer');
      if (!this.drawer) return;

      document.querySelectorAll('.js-toggle-cart').forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.openDrawer();
        });
      });

      this.bodyContainer = this.drawer.querySelector('.ajax-cart-drawer__body');
      this.itemsContainer = this.drawer.querySelector('#ajax-cart-items-container');
      this.subtotalContainer = this.drawer.querySelector('#ajax-cart-subtotal-price');
      this.recommendationsContainer = this.drawer.querySelector('#ajax-cart-recommendations-container');

      document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
        // Exclude forms within the featured collection on the cart page
        if (!form.closest('.template-cart .featured-collection')) {
            form.addEventListener('submit', this.handleFormSubmit.bind(this));
        }
      });

      this.drawer.addEventListener('click', (event) => {
        // Handle close button
        if (event.target.closest('.ajax-cart-drawer__close-icon, .ajax-cart-drawer__overlay')) {
          this.closeDrawer();
          return;
        }
      });

      this.bodyContainer.addEventListener('click', this.handleBodyClick.bind(this));
    },

    handleFormSubmit(event) {
      // If we are on the main cart page (identified by .template-cart), do not use AJAX. Let the form submit normally.
      if (document.querySelector('.template-cart')) {
        return;
      }
      event.preventDefault();
      const errorMessageContainer = this.drawer.querySelector('#ajax-cart-error-message');
      errorMessageContainer.style.display = 'none';
      const form = event.target;
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => {
            throw new Error(errorData.description || 'Ocurrió un error inesperado.');
          });
        }
        return response.json();
      })
      .then(data => {
        this.openDrawer();
      })
      .catch(error => {
        const errorMessageContainer = this.drawer.querySelector('#ajax-cart-error-message');
        errorMessageContainer.textContent = error.message;
        errorMessageContainer.style.display = 'block';
        this.openDrawer();
      });
    },

    openDrawer() {
      this.drawer.style.display = 'block';
      // Use a timeout to allow the display property to apply before adding the class for transition
      setTimeout(() => {
        this.drawer.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }, 10);
      this.renderCart();
    },

    closeDrawer() {
      this.drawer.classList.remove('is-visible');
      document.body.style.overflow = '';
      // Wait for the transition to finish before hiding the element
      setTimeout(() => {
          if (!this.drawer.classList.contains('is-visible')) {
             this.drawer.style.display = 'none';
          }
      }, 300); // Should match the transition duration in CSS
    },

    renderCart() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          this.updateCartCount(cart.item_count);
          this.itemsContainer.innerHTML = '';

          if (cart.item_count === 0) {
            this.itemsContainer.innerHTML = '<p>Tu carrito está vacío.</p>';
          } else {
            cart.items.forEach(item => this.itemsContainer.innerHTML += this.renderItem(item));
          }

          this.subtotalContainer.textContent = this.formatMoney(cart.total_price);

          // Fetch recommendations based on the current cart count
          this.fetchRandomProducts(cart.item_count);
        });
    },

    renderItem(item) {
      return `
        <div class="ajax-cart-item" data-key="${item.key}">
          <img src="${item.image}" alt="${item.title}" class="ajax-cart-item__image">
          <div class="ajax-cart-item__details">
            <p class="ajax-cart-item__title">${item.product_title}</p>
            <p class="ajax-cart-item__price">${this.formatMoney(item.final_line_price)}</p>
            <div class="ajax-cart-item__quantity">
              <button class="ajax-cart-item__quantity-btn" data-action="decrement">-</button>
              <input type="text" class="ajax-cart-item__quantity-input" value="${item.quantity}" readonly>
              <button class="ajax-cart-item__quantity-btn" data-action="increment">+</button>
            </div>
          </div>
          <button class="ajax-cart-item__remove" data-action="remove">${this.getRemoveIcon()}</button>
        </div>
      `;
    },

    handleBodyClick(event) {
      const button = event.target.closest('[data-action]');
      if (!button) return;

      const itemElement = event.target.closest('.ajax-cart-item');
      const key = itemElement.dataset.key;
      const action = button.dataset.action;
      const currentQuantity = parseInt(itemElement.querySelector('.ajax-cart-item__quantity-input').value);

      if (action === 'increment') this.updateQuantity(key, currentQuantity + 1);
      if (action === 'decrement') this.updateQuantity(key, currentQuantity - 1);
      if (action === 'remove') this.updateQuantity(key, 0);
    },

    updateQuantity(key, quantity) {
      const errorMessageContainer = this.drawer.querySelector('#ajax-cart-error-message');
      errorMessageContainer.style.display = 'none';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => {
            throw new Error(errorData.description || 'Ocurrió un error inesperado.');
          });
        }
        return response.json();
      })
      .then(() => this.renderCart())
      .catch(error => {
        errorMessageContainer.textContent = error.message;
        errorMessageContainer.style.display = 'block';
        this.renderCart();
      });
    },

    updateCartCount(count) {
      const cartCountElement = document.querySelector('[data-cart-count]');
      if (cartCountElement) {
        cartCountElement.textContent = count;
        cartCountElement.style.display = count > 0 ? 'flex' : 'none';
      }
    },

    fetchRandomProducts(itemCount) {
      fetch('/collections/all/products.json?limit=50')
        .then(response => response.json())
        .then(data => {
          if (!data.products || data.products.length === 0) return;

          const recommendationLimit = itemCount <= 2 ? 2 : 1;
          const shuffled = data.products.sort(() => 0.5 - Math.random());
          const selected = shuffled.slice(0, recommendationLimit);

          let productsHtml = '';
          selected.forEach(product => {
            const firstVariant = product.variants && product.variants[0] ? product.variants[0] : null;
            const priceDisplay = firstVariant ? this.formatShopPrice(firstVariant.price) : '';
            productsHtml += `
              <div class="ajax-cart-recommendation-item">
                <a href="/products/${product.handle}">
                    <img src="${product.images[0]?.src || ''}" alt="${product.title}" class="ajax-cart-recommendation-item__image">
                    <div class="ajax-cart-recommendation-item__details">
                    <p class="ajax-cart-recommendation-item__title">${product.title}</p>
                    <p class="ajax-cart-recommendation-item__price">${priceDisplay}</p>
                    <button class="button button--primary">Agregar al carrito</button>
                    </div>
                </a>
              </div>
            `;
          });

          if (this.recommendationsContainer) {
            this.recommendationsContainer.innerHTML = productsHtml;
          }
        })
        .catch(err => {
          console.error('Failed to fetch random products:', err);
          if (this.recommendationsContainer) {
            this.recommendationsContainer.innerHTML = '<p>No se pudieron cargar las recomendaciones.</p>';
          }
        });
    },

    formatMoney(cents) {
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);
    },

    // Formatter for prices coming from the products JSON endpoint (already in currency units, not cents)
    formatShopPrice(amount) {
        // amount may be a string like "3589.00" or a number already in units
        const num = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
        if (Number.isNaN(num)) return '';
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(num);
    },

    getRemoveIcon() {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>`;
    }
  };

  ajaxCart.init();
});